import { minutesToMilliseconds } from 'date-fns';

import { menuClient } from '@portal-clients/menu';

import { useClientQuery } from '@frontend/hooks';
import { useOptionalUser } from '@frontend/utils';

export interface UseMenuProps {
  shopId: string;
  placeId: string;
  onError?(error: Error): void;
}

export const getMenuQueryKey = (
  shopId: string,
  placeId: string,
  userLanguage: string | undefined,
) => ['menu', shopId, placeId, userLanguage ?? 'no-locale'];

export const useMenuQuery = ({ shopId, placeId, onError }: UseMenuProps) => {
  const { user } = useOptionalUser();

  return useClientQuery({
    queryKey: getMenuQueryKey(shopId, placeId, user?.locale),
    async onFetch() {
      return await menuClient.get(shopId, placeId);
    },
    onError,
    staleTime: minutesToMilliseconds(5),
  });
};
